import React, { useState } from 'react';
import { Briefcase, MapPin, Clock, Users, Send } from 'lucide-react';
import './Careers.css';

const Careers = () => {
  const [applicationForm, setApplicationForm] = useState({
    name: '',
    email: '',
    phone: '',
    position: '',
    experience: '',
    resume: null,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setApplicationForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setApplicationForm((prev) => ({
      ...prev,
      resume: e.target.files[0],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Application submitted successfully! We will contact you soon.');
    setApplicationForm({
      name: '',
      email: '',
      phone: '',
      position: '',
      experience: '',
      resume: null,
    });
  };

  return (
    <div className="careers-page">
      {/* Hero Section */}
<section className="careers-hero">
  <div className="hero-content">
    {/* <h1>Join Our Team</h1>s */}
    <p>
      Build your future with <strong>Megapix Machinery</strong> and help us
      deliver excellence in industrial solutions worldwide.
    </p>
  </div>
</section>


      {/* Why Work With Us */}
      <section className="why-work-section">
        <div className="container">
          <h2>Why Work With Us?</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">
                <Users size={32} />
              </div>
              <h3>Great Team</h3>
              <p>
                Work alongside experienced professionals in a collaborative
                environment that values innovation and expertise.
              </p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <Briefcase size={32} />
              </div>
              <h3>Career Growth</h3>
              <p>
                Opportunities for professional development, skill enhancement,
                and career advancement within the organization.
              </p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <Clock size={32} />
              </div>
              <h3>Work-Life Balance</h3>
              <p>
                Flexible working arrangements and policies that support a
                healthy work-life balance for all employees.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Application Form */}
      <section className="application-section">
        <div className="container">
          <h2>Apply Now</h2>
          <form className="application-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={applicationForm.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={applicationForm.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">Phone Number *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={applicationForm.phone}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="position">Position Applied For *</label>
                <input
                  type="text"
                  id="position"
                  name="position"
                  value={applicationForm.position}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="experience">Years of Experience *</label>
              <input
                type="text"
                id="experience"
                name="experience"
                value={applicationForm.experience}
                onChange={handleInputChange}
                placeholder="e.g., 5 years"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="resume">Upload Resume *</label>
              <input
                type="file"
                id="resume"
                name="resume"
                onChange={handleFileChange}
                accept=".pdf,.doc,.docx"
                required
              />
            </div>
            <button type="submit" className="submit-btn">
              <Send size={16} />
              Submit Application
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Careers;
